import React from "react";

const ExplorePageDetails = () => {
  return (
    <div className="mt-8 ml-8">
      <h1 className="font-bold text-2xl mb-4 text-primary-off-black dark:text-primary-off-white">
        Explore Page
      </h1>
      <label className="bg-sky-100 px-12 py-2 text-sky-800 font-semibold rounded-sm">
        Coming Soon!
      </label>
    </div>
  );
};

export default ExplorePageDetails;
